import config from '../config';

const externalLinks = {
    demoImages: 'https://drive.google.com/drive/folders/0B2LLTSqg_RezSFRfRmpqYlZNc3c',
    faq: config.production
        ? 'https://meupasseiovirtual.com/faq/'
        : 'https://test.meupasseiovirtual.com/faq/',
    termsOfUse: config.production
        ? 'https://meupasseiovirtual.com/policies/terms.html'
        : 'https://test.meupasseiovirtual.com/policies/terms.html',
    privacyPolicy: config.production
        ? 'https://meupasseiovirtual.com/policies/privacy.html'
        : 'https://test.meupasseiovirtual.com/policies/privacy.html'
};

export default externalLinks;
